<div class="payment-regulations" [class.gray]="statement.serviceType !== packageOption.tax_adviser">
  <div class="regulations_cont">
    <div class="regulations_wrap">
      @if (statement.isStandardPackage) {
        <div class="wysiwyg" [innerHTML]="'CHECKOUT.PAYMENT_REGULATIONS_STANDARD' | translate"></div>
      }
      @if (statement.isPremiumPackage) {
        <div class="wysiwyg" [innerHTML]="'CHECKOUT.PAYMENT_REGULATIONS_PREMIUM' | translate"></div>
        <div class="wysiwyg" [innerHTML]="'CHECKOUT.PREMIUM_SERVICE_INFO' | translate"></div>
      }
      <div class="regualtions">
        <div class="col" [class.singular]="statement.isStandardPackage">
          @if (statement.isPremiumPackage) {
            <span class="regulation-title">{{ "COMMON.REGULATION_TITLE_TAXANDO" | translate }}</span>
          }
          <ul>
            <li
              ><a (click)="openTermsAndConditions()">{{ "COMMON.TERMS_AND_CONDITIONS" | translate }}</a></li
            >
            <li
              ><a (click)="openPrivacyPolicy()">{{ "COMMON.PRIVACY_POLICY" | translate }}</a></li
            >
            <li
              ><a (click)="openPaymentCancellationDialog()">{{ "COMMON.PAYMENT_CANCELLATION" | translate }}</a></li
            >
          </ul>
        </div>
        @if (statement.isPremiumPackage) {
          <div class="col">
            <span class="regulation-title">{{ "COMMON.REGULATION_TITLE_TAX_ADVICE" | translate }}</span>
            <ul>
              <li
                ><a (click)="openPrivacyPolicyEtx()">{{ "COMMON.PRIVACY_POLICY_TAX_ADVICE" | translate }}</a></li
              >
              <li
                ><a (click)="openPaymentCancellationEtxDialog()">
                  {{ "COMMON.PAYMENT_CANCELLATION_TAX_ADVICE" | translate }}
                </a>
              </li>
            </ul>
          </div>
        }
      </div>
    </div>
  </div>

  @if (showRegulationCheckBox()) {
    <div class="regulations_cont">
      <div class="regulations_wrap checkbox_wrap">
        <mat-checkbox
          [(ngModel)]="termRegulationsIsChecked"
          (change)="clickTermRegulations.emit(termRegulationsIsChecked)"
          [attr.data-cy]="'checkboxTaxAdviserRegulations'"
        ></mat-checkbox>
        <div class="label_wrap">
          <span class="i_accept">{{ "COMMON.I_ACCEPT" | translate }}</span>
          <a class="link is-bold" (click)="openGeneralTaxAdvisorRulesDialog()">
            {{ "COMMON.TAX_ADVISER_LICENSE" | translate }}
          </a>
        </div>
      </div>
      <!-- <div class="regulations_wrap checkbox_wrap">
        <mat-checkbox
          [(ngModel)]="termRealDataIsChecked"
          (change)="clickTermRealData.emit(termRealDataIsChecked)"
          [attr.data-cy]="'checkboxTaxAdviserTermsRealData'"
          >
        </mat-checkbox>
        <div class="label_wrap"> {{'COMMON.REAL_DATA_ACCEPT' | translate }}</div>
      </div> -->
    </div>
  }
</div>
